import styled from "styled-components";

export const AssignmentInputButtonContainer = styled.div`
display:flex;
     align-items:center;
gap:2rem;
     @media only screen and (max-width: 564px) {
        flex-direction: column;
        /* margin-top:20px; */
     }

     label {
         /* margin-left: 20px; */
        @media only screen and (max-width: 564px) {
            width: 100%;
            margin-left: 0px;
        /* margin-top:20px; */
         }
     }
`

export const AssignmentButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 9px;
`

export const InstructorButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 1.3rem;
`

export const TableWrapper = styled.div`
margin-top: 3.7rem;
   background: #fff;
   box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
border-radius: 11px;
`;